import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import '../styles/Home.scss';
import section1Bg from '../assets/images/riize/section1/section1-bg.png';
import section1Title from '../assets/images/riize/section1/section1-title.png';
import section1Button from '../assets/images/riize/section1/section1-button.svg';
import riizeLottie from '../assets/images/riize/section1/riize.json';
import section2Img1 from '../assets/images/riize/section2/section2-1.png';
import section2Img2 from '../assets/images/riize/section2/section2-2.png';
import section2Img3 from '../assets/images/riize/section2/section2-3.png';
import section3Bg from '../assets/images/riize/section3/section3-bg.png';
import section3Content from '../assets/images/riize/section3/section3-content.png';
import section4 from '../assets/images/riize/section 4.png';
import section6Img1 from '../assets/images/riize/section6/section6-1.png';
import section6Img2 from '../assets/images/riize/section6/section6-2.png';
import arrowIcon from '../assets/images/riize/arrow.png';
import { FAQ_DATA } from '../assets/constants/faqData';
import { SLIDER_CONFIG } from '../assets/constants/sliderConfig';

const HomeRiize = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [openFaqIndex, setOpenFaqIndex] = useState<number>(0);
  const [dragStart, setDragStart] = useState<number>(0);
  const [dragOffset, setDragOffset] = useState<number>(0);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const section2Images = [section2Img1, section2Img2, section2Img3];

  const handleDotClick = (index: number) => {
    setCurrentSlide(index);
  };

  const handleDragStart = (
    e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    setDragStart(clientX);
    setIsDragging(true);
    setDragOffset(0);
  };

  const handleDragMove = (
    e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    if (!isDragging) return;
    const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    const diff = clientX - dragStart;
    setDragOffset(diff);
  };

  const handleDragEnd = () => {
    if (!isDragging) return;

    if (Math.abs(dragOffset) > SLIDER_CONFIG.DRAG_THRESHOLD) {
      if (dragOffset > 0 && currentSlide > 0) {
        setCurrentSlide(currentSlide - 1);
      }
      if (dragOffset < 0 && currentSlide < section2Images.length - 1) {
        setCurrentSlide(currentSlide + 1);
      }
    }

    setIsDragging(false);
    setDragOffset(0);
  };

  const handleFaqClick = (index: number) => {
    if (index === openFaqIndex) {
      setOpenFaqIndex(-1);
    }
    if (index !== openFaqIndex) {
      setOpenFaqIndex(index);
    }
  };

  return (
    <div className="home-container">
      <section className="home-section section-1">
        <div className="section-1-container">
          <img
            src={section1Bg}
            alt="Section 1 Background"
            className="section-1-bg"
          />
          <div className="section-1-content">
            <div className="section-1-title-wrapper">
              <img
                src={section1Title}
                alt="Section 1 Title"
                className="section-1-title"
              />
              <div className="section-1-title-text riize">
                2026 SEASON'S GREETINGS 속에 숨겨진 특별한 코드,
                <br />
                메시지를 입력해 리라즈와 놀아보세요!
              </div>
            </div>
            <Lottie animationData={riizeLottie} className="section-1-lottie" />
            <img
              src={section1Button}
              alt="Section 1 Button"
              className="section-1-button"
              onClick={() => navigate('/riize/waiting')}
            />
          </div>
        </div>
      </section>
      <section className="home-section section-2">
        <div className="section-2-container">
          <div className="section-2-banner riize">
            <span className="banner-text">TALK, FEEL, AND CONNECT</span>
          </div>
          <h2 className="section-2-title riize">리라즈와 더 가까워지는 순간</h2>
          <p className="section-2-subtitle riize">
            2026 SEASON'S GREETINGS(unrealriize)
            <br />
            관련 궁금증을 캐릭터와 함께 탐색해 보세요.
          </p>
          <div
            className="section-2-slider"
            onMouseDown={handleDragStart}
            onMouseMove={handleDragMove}
            onMouseUp={handleDragEnd}
            onMouseLeave={handleDragEnd}
            onTouchStart={handleDragStart}
            onTouchMove={handleDragMove}
            onTouchEnd={handleDragEnd}
            style={{
              cursor: isDragging ? 'grabbing' : 'grab',
              userSelect: 'none',
            }}
          >
            <div
              className="slider-wrapper"
              style={{
                transform: `translateX(calc(-${currentSlide} * 100% / ${SLIDER_CONFIG.SLIDE_COUNT} + ${dragOffset}px))`,
                transition: isDragging
                  ? 'none'
                  : `transform ${SLIDER_CONFIG.TRANSITION_DURATION}ms ease-in-out`,
              }}
            >
              {section2Images.map((img, index) => (
                <div key={index} className="slide">
                  <img
                    src={img}
                    alt={`Section 2 - ${index + 1}`}
                    draggable={false}
                  />
                </div>
              ))}
            </div>
            <div className="pagination-dots">
              {section2Images.map((_, index) => (
                <button
                  key={index}
                  className={`dot riize ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="home-section section-3 riize">
        <div className="section-3-container">
          <img
            src={section3Bg}
            alt="Section 3 Background"
            className="section-3-bg"
          />
          <div className="section-3-content">
            <h2 className="section-3-title riize">CHARACTERS</h2>
            <h3 className="section-3-subtitle riize">
              BRIIZE를 기다리는 친구들
            </h3>
            <div className="section-3-cards-wrapper">
              <img
                src={section3Content}
                alt="Section 3 Content"
                className="section-3-cards"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="home-section">
        <img src={section4} alt="Section 4" className="section-image" />
      </section>
      <section className="home-section section-5 riize">
        <div className="section-5-container">
          <h2 className="section-5-title riize">자주 묻는 질문</h2>
          <p className="section-5-subtitle riize">궁금한 점이 있으신가요?</p>
          <div className="faq-list">
            {FAQ_DATA.map((faq, index) => (
              <div key={index} className="faq-item riize">
                <button
                  className="faq-question riize"
                  onClick={() => handleFaqClick(index)}
                >
                  <span>{faq.question}</span>
                  <img
                    src={arrowIcon}
                    alt="arrow"
                    className={`faq-icon ${openFaqIndex === index ? 'open' : ''}`}
                  />
                </button>
                {openFaqIndex === index && (
                  <div className="faq-answer riize">{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="home-section section-6 riize">
        <img
          src={section6Img1}
          alt="Section 6-1"
          className="section-6-image first"
          onClick={() => navigate('/riize/waiting')}
        />
        <img src={section6Img2} alt="Section 6-2" className="section-6-image" />
      </section>
    </div>
  );
};

export default HomeRiize;
